import { Box, Heading, SimpleGrid } from "@chakra-ui/react";
import { CHAIN, EXTRAS } from "./homeContent";
import { Body, Card, CheckList, H3, Inner, Intro, Section, useHomeTokens } from "./primitives";

/** #chain — "Transparency you can audit". */
export const Chain = () => {
  const t = useHomeTokens();
  return (
    <Section id="chain" alt>
      <Inner>
        <Intro
          kicker="Advanced blockchain solutions"
          title="Transparency you can audit"
          lead="Secure, decentralized systems for organizations that need to prove what happened, not just claim it."
          maxW="700px"
        />
        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} gap="20px">
          {CHAIN.map((c) => (
            <Card key={c.title} p="30px">
              <H3 fontSize="1.3rem">{c.title}</H3>
              <Body fontSize=".95rem" lineHeight="1.65">
                {c.body}
              </Body>
              <CheckList items={c.points} mt="4px" gap="9px" />
            </Card>
          ))}
        </SimpleGrid>
        <SimpleGrid columns={{ base: 1, sm: 2, lg: 3 }} gap="12px" mt="20px">
          {EXTRAS.map((x) => (
            <Box
              key={x.title}
              p="20px 22px"
              borderRadius="14px"
              borderWidth="1px"
              borderColor={t.hairline}
              bg={t.cardTint}
              minW={0}
            >
              <Heading as="h4" fontSize=".98rem" fontWeight="600" letterSpacing="-0.025em" color={t.text} mb="6px">
                {x.title}
              </Heading>
              <Body fontSize=".86rem" lineHeight="1.55" color={t.textMuted}>
                {x.body}
              </Body>
            </Box>
          ))}
        </SimpleGrid>
      </Inner>
    </Section>
  );
};
